import { jsx } from 'react/jsx-runtime';

const Image = (props) => /* @__PURE__ */ jsx(
  "img",
  {
    loading: props.loading,
    src: props.src,
    alt: props.alt ?? "",
    role: props.role ?? "img",
    ...props
  }
);

export { Image as default };
//# sourceMappingURL=Image.js.map
